import axios from 'axios';
import sToast from '@/services/sToast';

/* axios default setting */
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.headers.get['Content-Type'] = 'application/json';

let axiosInstance = axios.create({
  //baseURL: /* window.location.origin + '/selfcareApi/selfcare/', */ process.env.VUE_APP_API_BASE_URL,
  baseURL:  window.location.origin + '/selfcareApi/selfcare/',
  method: 'GET',
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    let errorResponse;
    if (error.response) {
      errorResponse = error.response.data.message;
    } else if (error.request) {
      errorResponse = error.request;
    } else {
      errorResponse = error.response.data.message;
    }

    if(!errorResponse){
      errorResponse = error.response.data.rd;
    }

    sToast.show({
      message: errorResponse,
      intent: 'error',
      timeout: 8000,
    });
    return Promise.reject(error);
  }
);

export default axiosInstance;
